import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { Checkbox } from 'Components/Form/Checkbox'
import React, { useState } from 'react'
import QRCodePopup from '../../Popups/QRCodePopup'
import styles from './styles'

const ClientCodesTable = ({
  codes,
  classes,
  setSelectedRows,
  selectedRows,
  countCodesLinks,
  disabled,
}) => {
  const [selectedLink, setSelectedLink] = useState(null)

  return (
    <React.Fragment>
      <QRCodePopup
        isOpen={!!selectedLink}
        onCancel={() => {
          setSelectedLink(null)
        }}
        content={selectedLink}
      />
      <div className={classes.table}>
        <div className={classes.row} key={`code-row_header`}>
          <div className={classes.index} />
          <div className={classes.tableRow}>
            <div className={cn(classes.tableCell, classes.checkboxBlock)}>
              <Checkbox
                input={{
                  onChange: () => {
                    const set = new Set()
                    if (selectedRows.length !== codes.length) {
                      codes.forEach(row => {
                        set.add(row.id)
                      })
                    }
                    setSelectedRows(Array.from(set))
                  },
                  value: selectedRows.length === codes.length,
                  disabled,
                }}
                shouldListenToInputValue
              />
            </div>
            <div className={cn(classes.tableCell, classes.code)}>CODE</div>
            <div className={cn(classes.tableCell, classes.link)}>URL LINK</div>
            <div className={cn(classes.tableCell, classes.city)}>CITY</div>
            <div className={cn(classes.tableCell, classes.qrCodeColumn)}>
              QR
            </div>
          </div>
        </div>
        {codes.map((codeRow, index) => {
          return (
            <div className={classes.row} key={`code-row_${codeRow.id}`}>
              <div className={classes.index}>{index + 1}</div>
              <div className={classes.tableRow}>
                <div className={cn(classes.tableCell, classes.checkboxBlock)}>
                  <Checkbox
                    // className={classes.checkbox}
                    input={{
                      onChange: () => {
                        const set = new Set(selectedRows)
                        if (selectedRows.includes(codeRow.id)) {
                          set.delete(codeRow.id)
                        } else {
                          set.add(codeRow.id)
                        }
                        setSelectedRows(Array.from(set))
                      },
                      value: selectedRows.includes(codeRow.id),
                      disabled,
                    }}
                    shouldListenToInputValue
                  />
                </div>
                <div
                  className={cn(
                    classes.tableCell,
                    classes.code,
                    countCodesLinks.codes[codeRow.clientCode] > 1
                      ? classes.highlight
                      : '',
                  )}
                >
                  {codeRow.clientCode}
                </div>
                <div className={cn(classes.tableCell, classes.link)}>
                  <div className={classes.scroll}>{codeRow.clientLink}</div>
                </div>
                <div className={cn(classes.tableCell, classes.city)}>
                  {codeRow.city.name}
                </div>
                <div className={cn(classes.tableCell, classes.qrCodeColumn)}>
                  <Button
                    variant="outlined"
                    size="small"
                    className={classes.button}
                    onClick={() => {
                      setSelectedLink(codeRow.clientLink)
                    }}
                  >
                    QR Code
                  </Button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </React.Fragment>
  )
}

export default React.memo(withStyles(styles)(ClientCodesTable))
